import React, { useState, useEffect } from "react";
import { Spin, Row, Select } from "antd";
import i18n from "i18n";
import CustomModal from "components/CustomModal";
import { LanguageSettings } from "api/sms-api";
import { connect } from "react-redux";
import { RootState } from "store/store";

interface SelectLanguageModalProps {
  visible: boolean;
  closeModal: () => void;
  selectLanguageId: string | null;
  languageSettings: Array<LanguageSettings>;
  getLanguageSettingsListLoading: boolean;
  onSave: (selectedLanguageId: string | null) => void;
}

const SelectLanguageModal: React.FC<SelectLanguageModalProps> = ({
  visible,
  closeModal,
  selectLanguageId,
  languageSettings,
  getLanguageSettingsListLoading,
  onSave,
}) => {
  const [localSelectedLanguageId, setLocalSelectedLanguageId] = useState<
    string | undefined
  >(selectLanguageId ?? undefined);

  useEffect(() => {
    if (visible) {
      setLocalSelectedLanguageId(selectLanguageId ?? undefined);
    }
  }, [visible, selectLanguageId]);

  const EXCLUDED_LANGUAGE = "ja";
  const options = languageSettings
    .filter(({ code }) => code !== EXCLUDED_LANGUAGE)
    .map(({ name, id }) => ({
      label: name,
      value: id,
    }));

  const handleCloseModal = () => {
    closeModal();
  };

  const handleSave = () => {
    onSave(localSelectedLanguageId ?? null);
    closeModal();
  };

  return (
    <CustomModal
      title={i18n.t("survey.selectLanguage")}
      okText={i18n.t("common.save")}
      visible={visible}
      closeModal={handleCloseModal}
      onOk={handleSave}
    >
      {getLanguageSettingsListLoading ? (
        <Spin />
      ) : (
        <Row className="select-language">
          <Select
            value={localSelectedLanguageId}
            style={{ width: "250px" }}
            onChange={setLocalSelectedLanguageId}
            options={options}
          />
        </Row>
      )}
    </CustomModal>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    languageSettings: state.survey.languageSettings,
    getLanguageSettingsListLoading: state.survey.getLanguageSettingsListLoading,
  };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectLanguageModal);
